<template>
	<div class="page">
		<div class="searchBox">
			<el-form>
				<el-row>
					<el-col :span="5">
						<el-form-item>
							<el-input style="width:150px;margin-right: 10px;" placeholder="请输入关键字" v-model="keyword" @keyup.enter.native="clickSearch" clearable size="small"></el-input>
							<el-button @click="clickSearch" icon="el-icon-search" type="warning" size="small">搜索</el-button>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="审批状态" :label-width="formLabelWidth">
							<el-select style="width:100px" v-model="status" @change="clickSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:'-1'},{label:'待审批',value:'0'},{label:'审批中',value:'1'},{label:'已同意',value:'2'},{label:'已驳回',value:'-2'}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="4">
						<el-form-item label="订单类型" :label-width="formLabelWidth">
							<el-select style="width:100px" v-model="orderType" @change="clickSearch" size="small">
								<el-option
								v-for="item in [{label:'全部',value:'-1'},{label:'商品',value:'1'},{label:'洗美',value:'2'},{label:'病例',value:'3'},{label:'疫苗驱虫',value:'4'},{label:'医疗服务',value:'5'},{label:'寄养',value:'6'},{label:'挂号',value:'7'},{label:'活体',value:'8'},{label:'虚拟类',value:'9'},{label:'订金',value:'10'},{label:'大礼包',value:'11'}]"
								:key="item.value"
								:label="item.label"
								:value="item.value">
								</el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="9">
						<el-form-item label="退款时间" :label-width="formLabelWidth" >
							<el-date-picker @change="clickSearch" v-model="datetimerange" type="datetimerange" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" style="width: 340px;" size="small">
							</el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="2">
						<resetBtn @reset="reset" :size="'small'"></resetBtn>
					</el-col>
					<el-col :span="0">
						<el-col :span="2" style="float: right;">
							<!-- <el-button @click="$router.push({path:'/yiliao/guahaoAdd'})" icon="el-icon-plus" type="primary">新建</el-button> -->
						</el-col>
					</el-col>
				</el-row>
			</el-form>
		</div>
		<div class="pageConBox">
			<el-table :data="tableData" style="width: 100%">
				<el-table-column label="订单类型" prop="careId">
					<template slot-scope="scope">
						{{scope.row.orderTypeName}}
					</template>
				</el-table-column>
				<el-table-column label="订单编号" prop="memberName">
					<template slot-scope="props">
						<div>{{props.row.refund_no}}</div>
					</template>
				</el-table-column>
				<el-table-column label="发起人" prop="petName">
					<template slot-scope="props">
						<div>{{props.row.operation_info.create.create_user.user_name}}</div>
					</template>
				</el-table-column>
				<el-table-column label="发起时间">
					<template slot-scope="props">
						{{$public.FTime(props.row.operation_info.create.create_time)}}
					</template>
				</el-table-column>
				<el-table-column label="可退款日期">
					<template slot-scope="props">
						<div v-for="(item,index) in props.row.pets" :key="index">
							<el-popover placement="top-start" width="320" trigger="hover">
								<div>{{$public.FTime(item.beginDate)}} ~ {{$public.FTime(item.beginDate)}}</div>
								<div slot="reference">{{$public.FTime(item.beginDate,"MM-DD HH:mm")}} ~ {{$public.FTime(item.endDate,"MM-DD HH:mm")}}</div>
							</el-popover>
						</div>
					</template>
				</el-table-column>
				<el-table-column label="审批状态" >
					<template slot-scope="props">
						<span v-if="props.row.status===0" style="color:#1890FF">待审批</span>
						<span v-if="props.row.status===1">审批中</span>
						<span v-if="props.row.status===2">已同意</span>
						<span v-if="props.row.status===-2" style="color:red">已驳回</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" >
					<template slot-scope="props">
						<el-button v-if="props.row.status===2||props.row.status===-2" type="text" size="mini" @click="see(props.row)">查看</el-button>
						<el-button v-else type="text" size="mini" @click="see(props.row)">审批</el-button>
					</template>
				</el-table-column>
			</el-table>
			<page style="padding:10px 0;" :page="page.page" :total="page.total" @change="changePage"></page>
		</div>
	</div>
</template>
<script>
	import page from "../../../components/page.vue"
	import resetBtn from "../../../components/resetBtn.vue"
	export default {
		components:{page,resetBtn},
		data(){
			return{
				formLabelWidth:'80px',
				
				keyword:'',
				status:'-1',
				orderType:'-1',
				datetimerange:'',
				
				tableData:[],
				curItem:{},
				page:{
					page:1,
					pageSize:10,
					total:0
				},
			}
		},
		watch:{
			
		},
		computed:{
			userInfo(){
				return this.$store.state.userInfo;
			},
		},
		mounted(){
			this.getTableData();
		},
		methods: {
			reset(){
				this.keyword = ''
				this.status = '-1'
				this.orderType = '-1'
				this.datetimerange = ''
				this.page.page=1;
				this.getTableData()
			},
			// 查看
			see(row){
				this.curItem = row;
				this.$router.push({path:'/refund/approveSee',query:{id:row._id}})
			},
			clickSearch(){
				this.page.page=1;
				this.getTableData()
			},
			// 改变分页
			changePage(num){
				this.page.page = num;
				this.getTableData();
			},
			getTableData(){
				let params = {
					"status": this.status,   //  -1 全部 0：待审批、1：审批中、2：已同意、-2.已驳回
					orderType:this.orderType, 
					"startTime": "",
					"endTime": "",
					"pageIndex": this.page.page,
					"pageSize": this.page.pageSize,
					"keyword": (this.keyword).trim(),
				}
				if(this.datetimerange&&this.datetimerange.length==2){
					params.startTime=(''+new Date(this.datetimerange[0]).getTime()).substr(0,10);
					params.endTime=(''+new Date(this.datetimerange[1]).getTime()).substr(0,10);
				}
				let loading=this.$loading();
				this.$http.post(process.env.VUE_APP_Url_member+'/api/middleware/RefundAudit/List', params).then(res => {
					loading.close()
					if (res.code == 0) {
						this.tableData = res.data.data;
						this.page.total = res.data.count;
					}
				})
			}
		}
	}
</script>
<style scoped lang="scss">
.page{
	.searchBox{
		.el-form-item{
			margin-bottom:0;
		}
	}
	.pageConBox{
		min-height: 600px;
	}
}
</style>
